<template>
  <div id="login" :class="popupClasses">
    <div class="close__wrapper">
      <div class="popup__close" @click.prevent="closeModal(modal.name)">
        <img alt="image" src="@/assets/img/new/close.svg" />
      </div>
      <div class="header__popup">
        <span class="header__popup-title">Вывести средства</span>
      </div>
      <ValidationObserver v-slot="{ passes }">
        <form
          class="footer__popup"
          @submit.prevent="passes(sendOutputFormData)"
        >
          <AppSelect
            label="Куда выводить"
            :options="valutes"
            @updateValue="updateValue"
          />
          <!-- <select v-model="activeValute">
            <option default disabled value="">Выбрать валюту</option>
            <option
              v-for="valute in valutes"
              :value="valute._id"
              v-html="valute.title"
            ></option>
          </select> -->

          <MyForm
            v-if="inputs.length > 0"
            v-for="(form, index) in inputs"
            :key="index"
            :form="form"
            @formValue="setFormData"
          />

          <button type="submit" class="button-vlg2">
            Вывести
          </button>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
//
//
import { mapActions, mapState } from "vuex";
//
import MyForm from "./Form";
import AppSelect from "@/components/ui/AppSelect.vue";
export default {
  name: "OutputModal",
  props: ["modal", "bg"],
  //
  data() {
    return {
      activeValute: "",
      forms: {},
      inputs: []
    };
  },
  //
  computed: {
    ...mapState("valutes", ["valutes", "activeValutes", "activeForms"]),
    popupClasses() {
      if (window.screen.width < 680) {
        return ["mobpopup"];
      } else {
        return ["popup"];
      }
    }
  },
  methods: {
    ...mapActions("modals", ["closeModal"]),
    ...mapActions("modals", ["openModal"]),
    ...mapActions("auth", ["getProfile", "editProfile", "postOutputRequest"]),
    ...mapActions("valutes", ["getValutes", "getValute", "getValuteForms"]),
    updateValue(v) {
      this.activeValute = v["_id"];
    },
    async getSelectedValuteForms(id) {
      this.getValute({ id, type: "get" });
      return await this.getValuteForms({ id, type: "output" }).then(
        response => {
          response.data.result.map(form => {
            this.forms[form.key] = "";
          });
          this.inputs = this.activeForms.get[id];
        }
      );
    },
    sendOutputFormData() {
      this.postOutputRequest({
        valuteId: this.activeValute,
        forms: this.activeForms.get[this.activeValute].map(form => {
          form["value"] = this.forms[form.key];
          //
          return form;
        })
      }).then(result => {
        if (result.data.status) {
          this.openModal({
            name: "info",
            title: "Успешно!",
            message: "Ваша заявка отправлена!"
          });
        }
      });
    },

    Submit(data) {
      // if (this.verified === false) {
      //   alert("Подтвердите что вы не робот!");
      //   return;
      // }

      // this.verified = false;
      //

      return this.modal
        .success({ login: this.login, password: this.password })
        .then(response => {
          if (response) {
            this.closeModal(this.modal.name);
          }
          //
          return response;
        });
    },
    setFormData({ key, value }) {
      this.forms[key] = value;
      this.$forceUpdate();
    }
  },
  watch: {
    activeValute: {
      handler: async function(id) {
        await this.getSelectedValuteForms(id).then(() => {
          setTimeout(() => this.$forceUpdate(), 200);
        });
      }
    }
  },

  components: { VueRecaptcha, AppSelect, MyForm }
};
</script>

<style>
.forgot {
  margin-top: -12px !important;
  font-size: 13px;
  line-height: 16px;
  padding-left: 21px !important;
  color: red;
  margin-bottom: 36px;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/Modals/Output.vue